import React from "react";
import { ChevronDown } from "lucide-react";
import { INPUT_TYPE } from "../../../engine/indicators/indicatorTypes";
import { INTEGER_PRECISION } from "../../../engine/indicators/definitionHelpers";
import "./InputsTab.sass";

const CHEVRON_SIZE = 14;

/**
 * The Inputs tab (po-chart-visual-spec.md §5.4): "Name" and its field per
 * input of the registry — a number field limited as in PO, or a select
 * (MA type, source). Names are as in PO, like the indicator names.
 *
 * @param {object}   props
 * @param {object[]} props.inputs - registry inputs of the indicator
 * @param {object}   props.values - { [input key]: text of a number or a select value }
 * @param {(input: object, value: string) => void} props.onChange
 * @param {(input: object) => void} props.onCommit - a number field lost focus
 */
const InputsTab = ({ inputs, values, onChange, onCommit }) => (
  <div className="inputs-tab">
    {inputs.map((input) => {
      const fieldId = `indicator-input-${input.key}`;

      return (
        <div key={input.key} className="inputs-tab__row">
          <label className="inputs-tab__label" htmlFor={fieldId}>
            {input.label}
          </label>
          {input.type === INPUT_TYPE.SELECT ? (
            <span className="inputs-tab__select-wrap">
              <select
                id={fieldId}
                className="inputs-tab__field inputs-tab__field--select"
                value={values[input.key]}
                onChange={(event) => onChange(input, event.target.value)}
              >
                {input.options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <ChevronDown className="inputs-tab__chevron" size={CHEVRON_SIZE} aria-hidden="true" />
            </span>
          ) : (
            <input
              id={fieldId}
              type="text"
              className="inputs-tab__field"
              inputMode={input.precision === INTEGER_PRECISION ? "numeric" : "decimal"}
              autoComplete="off"
              value={values[input.key]}
              onChange={(event) => onChange(input, event.target.value)}
              onBlur={() => onCommit(input)}
            />
          )}
        </div>
      );
    })}
  </div>
);

export default InputsTab;
